import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initializeBlocklyMessages } from './lib/blockly/messageLoader.ts';

const isDevelopment = import.meta.env.DEV;

// Initialize Blockly messages asynchronously
async function initializeApp() {
  try {
    await initializeBlocklyMessages();
  } catch (error) {
    console.warn('Failed to initialize Blockly messages, continuing without them:', error);
  }

  // In development, we use React 19's <React.StrictMode>
  // In production, we disable it to avoid known issues with Blockly's FocusManager
  const root = ReactDOM.createRoot(document.getElementById('root')!);

  if (isDevelopment) {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    root.render(
      <App />
    );
  }
}

// Start the app
initializeApp();
